import { APP_INITIALIZER, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { UcManagementService } from './uc-management.service'

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (ucManagementService: UcManagementService) => () => ucManagementService.init(),
      deps: [UcManagementService],
      multi: true
    }
  ]
})
export class UcModule {}
